import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a66bb9fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-form" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["title", "disabled"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, " Suchen ", -1))

import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faSearch } from '@fortawesome/pro-light-svg-icons';


export default /*#__PURE__*/_defineComponent({
  emits: ['search'],
  setup(__props, { expose, emit }) {

library.add(faSearch);

const router = useRouter();


const form = ref({
  query: null as string | null,
  error: null as string[] | null,
});

const canSearch = computed(() => `${form.value.query || ''}`.trim().length >= 2);

const search = () => {
  if (canSearch.value) {
    router.push(`/suche/?q=${form.value.query}`);
    emit('search', form.value.query);
  } else {
    form.value.error = ['Bitte Suchbegriff eingeben'];
  }
};

expose({
  form,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      action: "/suche/",
      onSubmit: _withModifiers(search, ["prevent"])
    }, [
      _withDirectives(_createElementVNode("input", {
        placeholder: "Ihr Suchbegriff",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.query) = $event)),
        onInput: _cache[1] || (_cache[1] = ($event: any) => (form.value.error = null))
      }, null, 544), [
        [_vModelText, form.value.query]
      ]),
      (form.value.error)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "io-search-form__error",
            innerHTML: form.value.error
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "submit",
        title: _unref(canSearch) ? `Nach '${form.value.query}' suchen` : 'Suchen',
        disabled: !_unref(canSearch)
      }, [
        _createVNode(_unref(FontAwesomeIcon), { icon: "fa-light fa-search" }),
        _hoisted_5
      ], 8, _hoisted_4)
    ], 40, _hoisted_2)
  ]))
}
}

})